import LabelField from '@app/components/atoms/LabelField/LabelField'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import Grid from '@mui/material/Grid'
import MenuItem from '@mui/material/MenuItem'
import { styled } from '@mui/material/styles'
import TextField from '@mui/material/TextField'
import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

const DivCustomizer = styled('div')(() => ({
  '& .ck .ck-editor__main > .ck-editor__editable': {
    minHeight: '150px',
    borderBottomLeftRadius: '5px',
    borderBottomRightRadius: '5px',
  },
  '& .ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar': {
    borderTopLeftRadius: '5px',
    borderTopRightRadius: '5px',
  },
}))
const BasicInformationSection = ({ register, errors, getValues, setValue, status, control, trigger }) => {
  const { t } = useTranslation()

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <LabelField required title={t('CAMPAIGN.NAME')}>
          <TextField
            fullWidth
            name="name"
            size="small"
            variant="outlined"
            {...register('name')}
            error={errors.name ? true : false}
            helperText={errors.name?.message}
            onFocus={() => trigger('name')}
          />
        </LabelField>
      </Grid>
      <Grid item xs={12}>
        <LabelField title={t('CAMPAIGN.DESCRIPTION')}>
          <DivCustomizer>
            <CKEditor
              config={{
                removePlugins: ['EasyImage', 'ImageUpload', 'MediaEmbed'],
              }}
              data={getValues('description')}
              editor={ClassicEditor}
              id="description"
              name="description"
              onChange={(value, editor) => setValue('description', editor.getData())}
            />
          </DivCustomizer>
        </LabelField>
      </Grid>
      <Grid item xs={12}>
        <LabelField required title={t('CAMPAIGN.STATUS')}>
          <Controller
            control={control}
            name="status"
            render={() => (
              <TextField
                fullWidth
                select
                name="status"
                size="small"
                value={getValues('status')}
                variant="outlined"
                {...register('status')}
                error={errors.status ? true : false}
                helperText={errors.status?.message}
              >
                {status.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {t(option.name)}
                  </MenuItem>
                ))}
              </TextField>
            )}
          />
        </LabelField>
      </Grid>
    </Grid>
  )
}
export default BasicInformationSection
